import React, { memo } from 'react'
import { Box } from 'transfix-ui/core'
import { UNASSIGNED } from 'apps/fleet-planner/components/atoms/DriverAutosuggest'
import { DeactivatedDriverToolTip } from 'apps/fleet-planner/components/drivers/DeactivatedDriverTooltip'
import { InlineDisplayWrapper } from 'apps/fleet-planner/components/load-details/InlineDisplayWrapper'
import { DriverStatusType } from 'apps/fleet-planner/types'
import * as Types from 'apps/fleet-planner/types'
import { Avatar } from 'transfix-ui'

interface IDriverInlineDisplayProps extends Types.IInlineDisplayProps<Types.IDriver> {
  label: string
  isExternalDriver?: boolean
  /**
   * @default false
   */
  missingDriver?: boolean
}

export const DriverInlineDisplay = memo<IDriverInlineDisplayProps>(
  ({ isExternalDriver = false, label: labelProp, missingDriver = false, value: valueProp }) => {
    const { id: idProp, name: nameProp, status: statusProp } = valueProp || {}
    const name = idProp ? nameProp : undefined
    const isActive = statusProp === DriverStatusType.active

    /**
     * Show if the driver isn't active, but only for driver with id
     */
    const showTooltip = !isActive && !isExternalDriver && !!idProp
    const hasHighlight = missingDriver && !name

    return (
      <InlineDisplayWrapper
        label={labelProp}
        hasHighlight={hasHighlight}
        value={
          <Box display='flex' alignItems='center'>
            <Avatar
              name={nameProp === UNASSIGNED.text || !idProp ? undefined : nameProp}
              tooltipName={name || 'Unassigned'}
              size='xsmall'
            />
            <p className={`ml2 ${isActive ? '' : 'deactivated-driver-text'}`}>
              {name || 'Unassigned'}
            </p>
            {showTooltip && valueProp && (
              <Box pl={1} display='flex' alignItems='center'>
                <DeactivatedDriverToolTip driver={valueProp} />
              </Box>
            )}
          </Box>
        }
      />
    )
  }
)
